import { render, staticRenderFns } from "./ApproveAction.vue?vue&type=template&id=798b0e87&scoped=true&"
import script from "./ApproveAction.vue?vue&type=script&lang=ts&"
export * from "./ApproveAction.vue?vue&type=script&lang=ts&"
import style0 from "./ApproveAction.vue?vue&type=style&index=0&id=798b0e87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798b0e87",
  null
  
)

export default component.exports